import { httpService } from '../helper';
import { constants } from '../constants';

export const getFeeDetails = httpService().get.bind(null, constants.API.GET_FEE_DETAILS);
export const checkPaymentStatus = httpService().get.bind(null, constants.API.CHECK_PAYMENT_STATUS);
export const getPaymentLink = httpService().get.bind(this, constants.API.PAYMENT_LINK);
export const updatePaymentStatus = httpService().put.bind(this, constants.API.UPDATE_PAYMENT_STATUS);
